/**
 * VideoCardSkeleton — loading placeholder for RecommendedVideos widget (AC: 2).
 */
export default function VideoCardSkeleton() {
  return (
    <div className="flex-shrink-0 w-44 rounded-xl bg-slate-800/70 animate-pulse">
      <div className="h-24 bg-slate-700/50 rounded-t-xl" />
      <div className="p-3 space-y-2">
        <div className="h-2.5 bg-slate-700/50 rounded w-5/6" />
        <div className="h-2 bg-slate-700/50 rounded w-3/6" />
      </div>
    </div>
  );
}
